import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IRankingReport } from '../../../utils/interfaces/ranking-report';
import { IReportFilter } from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class RankingReportService {
  private readonly URI_API =
    environment.apiConfig.uri + 'DailyManagerialReport';

  constructor(private readonly httpClient: HttpClient) {}

  getRankingReport(
    filter: IReportFilter
  ): Observable<IResponse<IRankingReport[]>> {
    return this.httpClient.post<IResponse<IRankingReport[]>>(
      `${this.URI_API}/managerial`,
      filter
    );
  }
}
